import { render, staticRenderFns } from "./crosschain.vue?vue&type=template&id=86a852fc&"
import script from "./crosschain.vue?vue&type=script&lang=js&"
export * from "./crosschain.vue?vue&type=script&lang=js&"
import style0 from "./crosschain.vue?vue&type=style&index=0&id=86a852fc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports